import { __decorate } from "tslib";
import { Utils } from "@singularsystems/neo-core";
import React from "react";
import { injectable } from 'inversify';
/** Default icon factory supporting font-awesome strings. */
var IconFactory = /** @class */ (function () {
    function IconFactory() {
    }
    IconFactory.prototype.getIconComponent = function (iconOrName, style) {
        if (iconOrName !== undefined) {
            if (typeof iconOrName === "string") {
                return this.mapStringToIcon(iconOrName, style);
            }
            else {
                return this.createIconComponent(iconOrName, style);
            }
        }
        return undefined;
    };
    IconFactory.prototype.textOrIcon = function (textOrIcon, style) {
        if (textOrIcon.indexOf("fa-") === 0 || textOrIcon.indexOf("far-") === 0 || textOrIcon.indexOf("fas-") === 0) {
            return this.getIconComponent(textOrIcon, style);
        }
        else {
            return textOrIcon;
        }
    };
    IconFactory.prototype.mapStringToIcon = function (iconName, style) {
        var className = Utils.getFontAwesomeClass(iconName);
        if ((style === null || style === void 0 ? void 0 : style.solid) === false) {
            className = className.replace("fa ", "far ");
        }
        if ((style === null || style === void 0 ? void 0 : style.solid) === true) {
            className = className.replace("fa ", "fas ");
        }
        if (style === null || style === void 0 ? void 0 : style.fixedWidth) {
            className += " fa-fw";
        }
        if (style === null || style === void 0 ? void 0 : style.spin) {
            className += " fa-spin";
        }
        return React.createElement("i", { className: className });
    };
    IconFactory.prototype.createIconComponent = function (iconDescriptor, style) {
        return iconDescriptor;
    };
    IconFactory = __decorate([
        injectable()
    ], IconFactory);
    return IconFactory;
}());
export { IconFactory };
